import { render, staticRenderFns } from "./Kardex-add-medicine.vue?vue&type=template&id=e2d52446&scoped=true"
import script from "./Kardex-add-medicine.js?vue&type=script&lang=js&external"
export * from "./Kardex-add-medicine.js?vue&type=script&lang=js&external"
import style0 from "./Kardex-add-medicine.vue?vue&type=style&index=0&id=e2d52446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d52446",
  null
  
)

export default component.exports